import React from 'react'
import { useRouteError } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

// material-ui
import { useTheme } from '@mui/material/styles'
import { Box, Stack, Typography, Link } from '@mui/material'

// project imports
import logo from 'assets/icons/content-express.svg'

// ==============================|| ERROR PAGE ||============================== //

const ErrorElement = () => {
  const { t } = useTranslation('layout')
  const routeError = useRouteError()
  const theme = useTheme()

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'center',
        width: '100%',
        minHeight: '90vh',
        backgroundColor: theme.palette.background.paper,
      }}
    >
      <Stack spacing={5} width={['95%', '400px']} sx={{ justifyContent: 'center', alignItems: 'center' }}>
        <img src={logo} alt={t('routeError.alt')} width={50} height={50} />
        <Typography variant="h2" sx={{ color: theme.palette.grey[500] }}>
          {routeError?.statusText || t('routeError.fallback')}
        </Typography>
        <Link href="/" variant="body2" underline="hover" color="primary">
          {t('routeError.back')}
        </Link>
      </Stack>
    </Box>
  )
}

export default ErrorElement
